import type { ReactNode } from "react";

export function SlidingNavigation({ children, label }: { children: ReactNode; label: string }) {
  return <nav className={`sliding-navigation
  relative isolate flex items-center gap-1 p-1.5 [width:max-content] max-w-full [border:1px_solid_transparent] [border-radius:999px] [background:transparent]
  [&>a]:relative [&>a]:[z-index:1] [&>a]:flex [&>a]:items-center [&>a]:justify-center [&>a]:min-h-12.5 [&>a]:[padding:10px_18px] [&>a]:[border-radius:999px] [&>a]:text-muted-foreground [&>a:hover]:text-foreground
  [&>a[data-status=active]]:text-foreground [&>a[data-status=active]]:font-semibold
  [&>a[data-nav-current=true]]:text-foreground [&>a[data-nav-current=true]]:font-semibold [&>a]:[font-size:19.5px] [&>a]:font-medium [&>a]:[line-height:30px] [&>a]:whitespace-nowrap [&>a]:[outline:none] [&>a]:[transition:transform_.18s]
  [&>a:focus-visible]:underline [&>a:focus-visible]:[text-underline-offset:5px]
  [&>a:active]:[transform:scale(.98)]
  maxw-[960px]:[&>a]:px-2.5 maxw-[960px]:[&>a]:[font-size:18px]
  maxw-[600px]:w-full maxw-[600px]:gap-0.5 maxw-[600px]:[padding:5px] maxw-[600px]:overflow-x-auto maxw-[600px]:[scrollbar-width:none]
  maxw-[600px]:[&>a]:flex-1 maxw-[600px]:[&>a]:px-2 maxw-[600px]:[&>a]:min-h-9 maxw-[600px]:[&>a]:py-1 maxw-[600px]:[&>a]:text-sm
  maxw-[360px]:gap-0 maxw-[360px]:p-1
  maxw-[360px]:[&>a]:px-0.5
  motion-reduce:[&>a]:[transition:none]
`} aria-label={label} onFocusCapture={event => {
    // Keep keyboard-focused links visible in the horizontally scrollable menu.
    if (event.target instanceof HTMLElement) event.target.closest("a")?.scrollIntoView({ block: "nearest", inline: "nearest" });
  }}>{children}</nav>;
}
